import Icon from '../components/Icon.vue'

Icon.register({
  building: {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M436 480H416V24C416 10.7 405.3 0 392 0H56C42.7 0 32 10.7 32 24V480H12C5.4 480 0 485.4 0 492V512H448V492C448 485.4 442.6 480 436 480zM128 76C128 69.4 133.4 64 140 64H180C186.6 64 192 69.4 192 76V116C192 122.6 186.6 128 180 128H140C133.4 128 128 122.6 128 116V76zM128 172C128 165.4 133.4 160 140 160H180C186.6 160 192 165.4 192 172V212C192 218.6 186.6 224 180 224H140C133.4 224 128 218.6 128 212V172zM180 320H140C133.4 320 128 314.6 128 308V268C128 261.4 133.4 256 140 256H180C186.6 256 192 261.4 192 268V308C192 314.6 186.6 320 180 320zM256 480H192V396C192 389.4 197.4 384 204 384H244C250.6 384 256 389.4 256 396V480zM320 308C320 314.6 314.6 320 308 320H268C261.4 320 256 314.6 256 308V268C256 261.4 261.4 256 268 256H308C314.6 256 320 261.4 320 268V308zM320 212C320 218.6 314.6 224 308 224H268C261.4 224 256 218.6 256 212V172C256 165.4 261.4 160 268 160H308C314.6 160 320 165.4 320 172V212zM320 116C320 122.6 314.6 128 308 128H268C261.4 128 256 122.6 256 116V76C256 69.4 261.4 64 268 64H308C314.6 64 320 69.4 320 76V116z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/building.js
// module id = cWpK
// module chunks = 144